import './ListViewLink.scss';

interface ListViewLinkProps {
  label: string;
  handleClick: () => void;
  customClasses?: string;
  isReadOnly?: boolean;
}

export const ListViewLink = ({
  label,
  handleClick,
  customClasses = '',
  isReadOnly = false,
}: ListViewLinkProps) => {
  return (
    <div
      className={`listview-link ${customClasses} ${isReadOnly ? 'disabled' : ''}`}
      onClick={handleClick}
    >
      {label}
    </div>
  );
};
